import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import useProjectStore from "@/shared/zustand/projectManagementStore";
import { HOST_MODES } from "@/constants";
import { fetchProjectHierarchy } from "@/core/api/api";
import useToastStore from "@/shared/zustand/toastStore";
import { FolderOpen } from "lucide-react";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
export const ProjectBreadcrumbs = ({ setCurrentHostMode, setModesHistory, modesHistory, project, projectIdFromURL, }) => {
    const { navigationHistory, setSelectedProject, setShowProjectPage, clearHistory, setNavigationHistory, setSelectedFile, setPreviewDialogVisible, } = useProjectStore();
    const showToast = useToastStore((state) => state.showToast);
    // console.log("projectIdFromURL in breadcrumbs", projectIdFromURL);
    useMemo(async () => {
        if (!projectIdFromURL)
            return;
        const { responseData, error } = await fetchProjectHierarchy(projectIdFromURL);
        if (error) {
            console.error("Error fetching project hierarchy in breadcrumbs", error);
            showToast("error", "Error", 
            // "Error fetching project hierarchy in breadcrumbs"
            error.errorMessage);
            return;
        }
        else {
            const heirarchyData = responseData?.heirarchy;
            if (heirarchyData && heirarchyData?.length > 0) {
                const reversedHierarchy = heirarchyData.reverse();
                const newNavigationHistory = reversedHierarchy.map((project) => ({
                    _id: project._id,
                    name: project.name,
                    description: project.description,
                    user: project.user,
                    file_urls: project.file_urls,
                    files: project.files || [],
                    parent: project.parent,
                    children: project.children,
                    context: project.context || {},
                    created_by: project.created_by,
                    timestamp: project.timestamp,
                    conversation: project.conversation || [],
                    conversations: project.conversations || [],
                }));
                setNavigationHistory(newNavigationHistory);
                const lastProject = newNavigationHistory[newNavigationHistory.length - 1];
                if (lastProject) {
                    setSelectedProject(lastProject);
                    // setShowProjectPage(true); // it should not open the project page
                }
            }
        }
    }, [projectIdFromURL]);
    const getBreadcrumbItems = () => {
        const items = [
            {
                label: "Projects",
                template: (item) => (_jsxs(Button, { type: "button", onClick: () => {
                        setCurrentHostMode(HOST_MODES["Project Mode"]);
                        setModesHistory((prev) => [
                            ...prev,
                            {
                                mode: HOST_MODES["Project Mode"],
                                openedBy: `BreadCrumb - Projects`,
                            },
                        ]);
                        setSelectedProject(null);
                        setShowProjectPage(false);
                        clearHistory();
                        setSelectedFile(null);
                        setPreviewDialogVisible(false);
                    }, className: "text-xs flex items-center gap-x-2 hover:text-[#5928ED] text-[#111827] transition-colors duration-200", children: [_jsx("span", { className: "flex items-center justify-center w-4 h-4", children: _jsx(FolderOpen, { color: "#5928ed" }) }), _jsx("span", { className: "font-medium", children: item.label })] })),
            },
        ];
        navigationHistory?.forEach((historyItem, index) => {
            const truncatedLabel = historyItem.name.length > 12
                ? `${historyItem.name.slice(0, 9)}...`
                : historyItem.name;
            items.push({
                label: historyItem.name,
                template: (item) => (_jsx(Button, { type: "button", onClick: () => {
                        const newHistory = navigationHistory.slice(0, index + 1);
                        setNavigationHistory(newHistory);
                        const lastProject = newHistory[newHistory.length - 1];
                        setSelectedProject(lastProject);
                        setCurrentHostMode(HOST_MODES["Project Mode"]);
                        setModesHistory((prev) => [
                            ...prev,
                            {
                                mode: HOST_MODES["Project Mode"],
                                openedBy: `BreadCrumb - History - ${lastProject.name}`,
                            },
                        ]);
                        setShowProjectPage(true);
                        setSelectedFile(null);
                        setPreviewDialogVisible(false);
                    }, "data-pr-tooltip": historyItem.name, title: historyItem.name, className: "breadcrumb-item hover:text-[#5928ED] align-middle break-words w-full !min-w-[unset] text-xs text-[#111827] font-medium transition-colors duration-200 text-ellipsis overflow-hidden", children: truncatedLabel })),
            });
        });
        return items;
    };
    return (_jsxs("div", { className: "w-[calc(100%-105px)] flex justify-between items-center", children: [_jsx(Tooltip, { target: ".breadcrumb-item", position: "top" }), _jsx(BreadCrumb, { model: getBreadcrumbItems(), className: "w-full p-0 bg-transparent border-none flex-wrap", pt: {
                    root: { className: "border-none bg-transparent p-0" },
                    menuitem: {
                        className: "bg-transparent p-0 ",
                    },
                    separator: { className: "text-[#D0D5DD]" },
                    label: { className: "hidden" },
                } })] }));
};
